import uuid from 'uuid'
import { STOP_TYPE } from 'apps/fleet-planner/constants/loads'
import { ShipmentStopSchemaType, IShipmentStop } from 'apps/fleet-planner/schema'

interface IGetDefaultStopProps {
  defaultValues: Partial<
    Pick<ShipmentStopSchemaType, 'stopType' | 'stopSequence' | 'startAt' | 'endAt'>
  >
  /**
   * @example 'America/New_York'
   * @default moment.tz.guess() // local timezone
   */
  timezone?: string
}

/**
 * Helper function to generate a default schema value for IShipmentStop
 * in the Create Load form
 */
export const getDefaultStop = (props: IGetDefaultStopProps): IShipmentStop => {
  const { defaultValues } = props || {}
  const { stopType = STOP_TYPE.pickup, stopSequence = 1, startAt = '', endAt = null } =
    defaultValues || {}

  return {
    id: uuid(),
    stopType,
    stopSequence,
    weight: '',
    unitQuantity: '',
    unit: '',
    poNumber: '',
    bolNumber: '',
    appointmentNumber: '',
    referenceNumber: '',
    address: {
      subdivisionCode: '',
      locality: '',
      postalCode: '',
    },
    city: '',
    stateCode: '',
    startAt,
    endAt,
    notes: '',
    facility: {} as any,
    facilityContact: {},
  }
}
